import React from 'react';
import PropTypes from 'prop-types';

/**
 * Edit (pencil) icon for CDS Pasajero Frecuente account actions.
 * Inlined rather than imported as an asset so the stroke follows `currentColor`
 * and the size can be set from the consumer's class names.
 * @param {object} props
 * @param {string} [props.className]
 * @returns {React.ReactElement}
 */
function CdsFpEditIcon({ className }) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M9.33333 4.00008L12 6.66675M2.52133 10.8734L2 14.0001L5.12667 13.4788C5.66986 13.3885 6.17126 13.1307 6.56067 12.7414L13.6133 5.68808C13.8609 5.44054 13.9999 5.10481 13.9999 4.75475C13.9999 4.40469 13.8609 4.06896 13.6133 3.82142L12.1793 2.38675C12.0567 2.26399 11.9111 2.1666 11.7509 2.10016C11.5906 2.03371 11.4188 1.99951 11.2453 1.99951C11.0718 1.99951 10.9001 2.03371 10.7398 2.10016C10.5795 2.1666 10.4339 2.26399 10.3113 2.38675L3.25867 9.44008C2.86948 9.82931 2.61168 10.3305 2.52133 10.8734Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

CdsFpEditIcon.propTypes = {
  className: PropTypes.string,
};

CdsFpEditIcon.defaultProps = {
  className: '',
};

export default CdsFpEditIcon;
